import { Box, HStack, Text } from "@chakra-ui/layout";
import { FC, ReactNode } from "react";

import { GhostButton, SolidButton } from "~/src/components/common/Button";
import { Modal } from "~/src/components/common/Modal";

export type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  /** Modal content width (default 90% of viewport). */
  width?: string;
};

export const ConfirmDialog: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "保存",
  cancelText = "キャンセル",
  width = "90vw",
}) => {
  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose} width={width}>
      <Box my="16px">
        {typeof message === "string" ? <Text>{message}</Text> : message}
      </Box>
      <HStack mt="16px" spacing="8px" justifyContent="flex-end">
        <GhostButton onClick={onClose}>{cancelText}</GhostButton>
        <SolidButton onClick={onConfirm}>{confirmText}</SolidButton>
      </HStack>
    </Modal>
  );
};
